module.exports = __webpack_public_path__ + "media/packs/images/flags/AT-17d2991bea3951f84dd7272af78c0e91.png";